window.components = {
  ...window.components,
  'DictationHeatMap': require('../components/DictationHeatMap'),
  'DictationPerformance': require('../components/DictationPerformance')
}

window.mountComponents(window.components);
